export default __webpack_public_path__ + "static/media/shoes.74bfa580.jpeg";